import { createElement, modal, validateField, loadingGif } from "commonAssets/js/helpers"
import { outputDiv, reCAPTCHAv3, loading } from "commonAssets/js/constants"
import { customSubmitClaim } from "./customSubmitClaim"

export const customVinLookup = () => {
    const titleHtml = `VIN Lookup`
    const bodyHtml = formHtml

    const title = createElement("h2", { class: "page-title mt-2 mb-4" }, [], titleHtml)
    const body = createElement("div", { class: "page-body" }, [], bodyHtml)

    outputDiv.appendChild(title)
    outputDiv.appendChild(body)

    // Commented out for the updated HTML
    vinLookupController()
}

const updatedHtml = `
  <div class="fs-4 text-center mb-3">
        The VIN Lookup tool will be available soon, please check back soon. <br>
        You can also email the Settlement Administrator at 
        <a href="mailto:info@turbochargersettlement.com">info@turbochargersettlement.com</a>.
  </div>`

const formHtml = `
    <form class="vin-lookup-form border rounded p-3" id="vin-lookup-form" method="post" style="">
        <div class="mb-3" role="alert">
            <p class="mb-0"><strong>The Settlement Class includes the following models:</strong> Model Year 2013–2016 Land Rover Range Rover Evoque, Model Year 2015–2017 Land Rover Discovery Sport, or Model Year 2013–2015 Land Rover LR2 vehicles sold or leased, and registered in one of the fifty (50) states (or the District of Columbia) on or before September 27, 2024 and equipped with a brazed scroll turbocharger. If you are unsure if your vehicle is included in the class, please enter your VIN below:</p>
        </div>
        <div class="form-group mb-3">
            <label class="form-label" for="vin">
                VIN: <span class="error"></span>
            </label>
            <input type="text" class="form-control" id="vin" name="vin" data-validate="" required>
        </div>
        <button type="submit" class="btn btn-primary">Submit</button>
    </form>
    <div id="vin-lookup-result"></div>
    `

const vinLookupController = () => {

    const c = new customSubmitClaim

    const form = document.getElementById('vin-lookup-form')
    form.addEventListener('submit', (e) => {

        e.preventDefault()

        const vinResultElem = document.querySelector("#vin-result")
        if (vinResultElem) {
            vinResultElem.remove()
        }

        loadingGif(loading, "show")

        const vin = form.vin.value
        if (vin === '' || vin.length < 17) {
            form.vin.classList.add('is-invalid')
            form.vin.value = ''
            loadingGif(loading, "hide")
            modal('Error', 'Please enter a valid VIN number.')
            return
        }

        if (form.vin.classList.contains('is-invalid')) {
            form.vin.classList.remove('is-invalid')
        }

        form.vin.classList.add('is-valid')

        // init the api call
        let lookup = {
            domain: c.claim.data.domain,
            searchFields: {
                vin: vin // corrected variable name from 'value' to 'vin'
            }
        }

        let valid = validateField(form.vin)
        if (!valid) {
            modal('Error', 'Invalid VIN format.')
            return
        }

        grecaptcha.enterprise.execute(reCAPTCHAv3, { action: 'submit' }).then(token => {
            lookup.token = token
            c.claim.api.classMemberSearchV2Post({}, lookup).then(result => {

                loadingGif(loading, "hide")

                // Generic error handling
                if (result.data.error) {
                    if (result.data.error === "The information provided does not match our records, please try again.") {
                        // update to custom error message
                        result.data.error = `The VIN entered is not identified as belonging to a Class Vehicle. If you believe your vehicle is covered by the class definition, please contact the Settlement Administrator at <a href="mailto:info@turbochargersettlement.com">info@turbochargersettlement.com</a>.`
                    }
                    // toggleFieldError(input, true, "Required")
                    modal('Error', `<p class="fw-bold">${result.data.error}</p>`)
                    form.vin.value = ''
                    form.vin.classList.remove('is-valid')
                    return
                }

                // If result.data:{} is empty, show an error
                if (Object.keys(result.data).length === 0) {
                    modal('Error', 'No data found for the provided VIN. Please check and try again.')
                    return
                }

                // If the VIN is valid, show the claim form
                if (result.data.vin) {
                    form.vin.value = ''
                    form.vin.classList.remove('is-valid')

                    const vinResult = document.getElementById('vin-lookup-result')
                    vinResult.innerHTML = `
                        <div class="alert alert-success mt-3" id="vin-result" role="alert">
                            <p class="d-none">${result.data.message}</p>
                            <p class="mb-0 text-center">This VIN is eligible.</p>
                        </div>`
                }

            }).catch(error => {
                console.error(error)
                loadingGif(loading, "hide")
                modal('Error', 'An error occurred while checking the VIN. Please try again.')
            })
        })
    })
}